import * as z from "zod";
import { mutator } from "./mutator";

export const permanentlyDeleteWorkflow = mutator({
  schema: z.object({ workflowId: z.string() }),
  resolve: {
    workflow: { kind: "deletedWorkflow", from: "workflowId" },
  },
  permissions: [
    {
      permission: "space:manage",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
  ],
  fn: async ({ tx, args: { workflow } }) => {
    await tx.mutate.workflows.delete({ id: workflow.id });
  },
});
